<template>
  <div class="confirmContent" id="confirmContent" @click="closeConfirm(opts[0].maskClick)">
    <div class="box">
      <div class="title" v-if="title" v-html="title"></div>
      <div class="contentMess">{{mes}}</div>
      <!-- <span @click.stop="closeConfirm(false, opts)">确定</span> -->
      <div class="bottom" v-if="typeof opts == 'function'">
        <span class="cancel" @click.stop="closeConfirm(false)">取 消</span>
        <span class="sure" @click.stop="closeConfirm(false, opts)">确 定</span>
      </div>
      <div class="bottom" v-else>
        <span
          href="javascript:;"
          class="yd-confirm-btn"
          :key="index"
          v-for="(item, index) in opts"
          :class="getClass(item,index)"
          @click.stop="closeConfirm(item.stay, item.callback)"
        >{{item.txt}}</span>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
export default {
  props: {
    title: String,
    mes: String,
    opts: {
      type: [Array, Function],
      default: () => {}
    }
  },
  created() {},
  methods: {
    getClass(item, index) {
 
      if (this.opts.length == 1) {
        return "one";
      } else {
        if (index == 0) {
        
          if (item.left) {
            return "sure";
          } else {
            return "cancel";
          }
        } else {
      
          if (item.left) {
            return "cancel";
          } else {
            return "sure";
          }
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
.confirmContent {
  position: fixed;
  top: 0;
  width: 100%;
  max-width: 750px;
  height: 100%;
  z-index: 10;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1601;
  .box {
    background: #fff;
    width: 90%;
    padding: 0.2rem 0.59rem;
    padding-top: 0.5rem;
    border-radius: 0.3rem;
    text-align: center;
    .title {
      color: #000000;
      font-size: 0.34rem;
      padding-bottom: 0.3rem;
    }
    .contentMess {
      display: inline-block;
      text-align: left;
      font-size: 0.32rem;
      // padding: 0 0.20rem;
      line-height: 0.6rem;
      text-align: justify;
      white-space: pre-line;
    }
    .bottom {
      padding-top: 0.63rem;
      padding-bottom: 0.2rem;
      span {
        width: 2.2rem;
        height: 0.88rem;
        border-radius: 0.44rem;
        line-height: 0.88rem;
        font-size: 0.32rem;
        display: inline-block;
        &.cancel {
          color: #808080;
          font-size: 0.34rem;
        }
        &.sure {
          color: #ff7f00;
          font-size: 0.34rem;
        }
        &.one {
          width: 4.4rem;
          color: #000000;
          background: #ffdc00;
        }
      }
    }
  }
}
</style>
